import {Locales} from '@netx/core-next/locales/utils/Locales';
import {ShareLinkField, ShareLinkStatus} from './schema';

export const ShareLinksLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.links'),
}));

export const ShareLinkTitle = Locales((i18n) => ({
	CONFIRM_DELETE: i18n('i18n.shareLinkDeleteConfirmTitle'),
	CONFIRM_BULK_DELETE: i18n('i18n.shareLinkBulkDeleteConfirmTitle'),
	SHARE_LINK: i18n('i18n.share'),
	SHARE_LINKS: i18n('i18n.links'),
}));

export const ShareLinksManageLabel = Locales((i18n) => ({
	DELETE: i18n('i18n.delete'),
	COPY_LINK: i18n('i18n.copyLink'),
	DUPLICATE: i18n('i18n.duplicate'),
	EDIT: i18n('i18n.edit'),
	SHARE: i18n('i18n.share'),
}));

export const ShareLinkMessage = Locales((i18n) => ({
	CONFIRM_DELETE: i18n('i18n.actionPermanent'),
	CONFIRM_BULK_DELETE: (count: number) =>
		i18n('i18n.actionPermanentBulk', {count}),
	ERROR: i18n('i18n.error'),
	EXPIRED: i18n('i18n.shareLinkDisabled_expired'),
	NO_MATCHING_RECORDS: i18n('i18n.noRecords'),
	NO_RECORDS: i18n('i18n.emptyShareLinksList'),
	RESOURCE_MISSING: i18n('i18n.shareLinkDisabled_resourceMissing'),
	USER_MISSING: i18n('i18n.shareLinkDisabled_userMissing'),
}));

export const ShareLinkSubTitle = Locales((i18n) => ({
	EDIT: i18n('i18n.edit'),
	NEW: i18n('i18n.new'),
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
}));

export const ShareLinkStatusLabel = Locales((i18n) => ({
	[ShareLinkStatus.ACTIVE]: i18n('i18n.enabled'),
	[ShareLinkStatus.USER_DISABLED]: i18n('i18n.disabled'),
	[ShareLinkStatus.EXPIRED]: i18n('i18n.expired'),
	[ShareLinkStatus.SHARE_RESOURCE_MISSING]: i18n('i18n.invalidResource'),
	[ShareLinkStatus.USER_RESOURCE_MISSING]: i18n('i18n.invalidUser'),

	DISABLED: i18n('i18n.disabled'),
	ENABLED: i18n('i18n.enabled'),
	ANY: i18n('i18n.any'),
}));

export const ShareLinkStep = Locales((i18n) => ({
	SETTINGS: i18n('i18n.settings'),
	ATTRIBUTES: i18n('i18n.attributes'),
}));

export const ShareLinkSettingsTitle = Locales((i18n) => ({
	ALLOW_DOWNLOAD: i18n('i18n.allowDownload'),
	CATEGORY: i18n('i18n.category'),
	ENABLED: i18n('i18n.enableLink'),
	EXPIRATION_DATE: i18n('i18n.expirationDate'),
	LINK: i18n('i18n.url'),
	PASSWORD: i18n('i18n.password'),
	TITLE: i18n('i18n.title'),
	INCLUDE_PDF: i18n('i18n.includePDF'),
	EXPORT_ATTRIBUTES: i18n('i18n.exportAttributes'),
	EMBED_ATTRIBUTES: i18n('i18n.embedAttributes'),
	INCLUDE_SUBFOLDERS: i18n('i18n.includeSubfolders'),
}));

export const ShareLinkSettingsDescription = Locales((i18n) => ({
	ALLOW_DOWNLOAD: i18n('i18n.shareLinkSettingsDescription_allowDownload'),
	ENABLED: i18n('i18n.shareLinkSettingsDescription_enabled'),
	EXPIRATION_DATE: i18n('i18n.shareLinkSettingsDescription_expirationDate'),
	LINK: i18n('i18n.shareLinkSettingsDescription_link'),
	PASSWORD: i18n('i18n.shareLinkSettingsDescription_password'),
	TITLE: i18n('i18n.shareLinkSettingsDescription_title'),

	EMBED_ATTRIBUTES: i18n('i18n.shareLinkSettingsDescription_embedAttributes'),
	EXPORT_ATTRIBUTES: i18n('i18n.shareLinkSettingsDescription_exportAttributes'),
	INCLUDE_PDF: i18n('i18n.shareLinkSettingsDescription_includePDF'),
	INCLUDE_SUBFOLDERS: i18n(
		'i18n.shareLinkSettingsDescription_includeSubfolders',
	),
}));

export const ShareLinkColumnLabel = Locales<
	Partial<Record<keyof typeof ShareLinkField, string>>
>((i18n) => ({
	[ShareLinkField.title]: i18n('i18n.title'),
	[ShareLinkField.assetCount]: i18n('i18n.assetCount'),
	[ShareLinkField.creationDate]: i18n('i18n.created'),
	[ShareLinkField.userLabel]: i18n('i18n.createdBy'),
	[ShareLinkField.expirationDate]: i18n('i18n.expirationDate'),
	[ShareLinkField.lastDownloadedDate]: i18n('i18n.lastDownloadedDate'),
	[ShareLinkField.status]: i18n('i18n.status'),
}));
